export const SET_PROJECT_LAYERS_SUCCESS = 'layers/SET_PROJECT_LAYERS_SUCCESS';
export const SET_LAYER_FEATURES_SUCCESS = 'layers/SET_LAYER_FEATURES_SUCCESS';
export const SET_ENTIRE_TRACK = 'layers/SET_ENTIRE_TRACK';
export const SET_TRACK_INFO = 'layers/SET_TRACK_INFO';
export const SET_TRACK_OBSERVATIONS = 'SET_TRACK_OBSERVATIONS';
export const SET_TRACK_OBSERVATIONS_MEDIA = 'SET_TRACK_OBSERVATIONS_MEDIA';
export const CLEAR_ENTIRE_TRACK = 'layers/CLEAR_ENTIRE_TRACK';
export const SET_SELECTED_LAYERS = 'layers/SET_SELECTED_LAYERS';
export const SET_ALERT_FEATURES_SUCCESS = 'layers/SET_ALERT_FEATURES_SUCCESS';
